import { ResetPassword as SharedResetPassword } from '@valiant/ui-shared'
import { useAuth } from '../AuthProvider'
import { useQueryParams } from '@valiant/ui-shared'

export function ResetPassword() {
  const auth = useAuth()

  const queryParams = useQueryParams()
  const firstTime = queryParams.firstTime

  return (
    <div className="custom-gradient-background">
      <SharedResetPassword
        variant="admin"
        title={firstTime ? 'Set your password' : 'Reset your password'}
        onResetPassword={auth.resetPassword}
        onClearSession={auth.signout}
      />
    </div>
  )
}
